import { ADJUSTER_REPORT_CULPRIT_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import ImageFlow from '@/modules/adjusterReportModules/IncidentParticipants/pages/common/imageFlow/ImageFlow';
import { useNavigate, useParams } from 'react-router-dom';

const CulpritImageFlow = () => {
  const navigate = useNavigate();
  const params = useParams();

  const finishFlow = () => {
    navigate(
      ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +params.id!,
      }).ADJUSTER_VEHICLE.PreviewImages,
      { replace: true },
    );
  };
  const navigateBack = () => {
    navigate(
      ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +params.id!,
      }).ADJUSTER_VEHICLE.damagedPoints,
      { replace: true },
    );
  };
  return (
    <ImageFlow
      finishFlow={finishFlow}
      navigateBack={navigateBack}
      filetype="property"
    />
  );
};

export default CulpritImageFlow;
